import { ReactNode } from 'react';

const SectionFrame = ({ children }: { children: ReactNode }) => (
	<div
		style={{
			borderStyle: 'solid',
			borderColor: '#C7CFD7',
			borderWidth: '1px',
			borderRadius: '12px',
			boxShadow: '0px 16px 40px 0px #0000000D',
			display: 'flex',
			flexDirection: 'column',
			padding: '38px',
			gap: '48px',
			margin: 'auto',
		}}
	>
		{children}
	</div>
);

export default SectionFrame;
